import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DataARTransactionItemModel } from '../../../../models/accountsReceivable/data-ar-transaction-item.model';
import { EnumValidValueItemModel } from '../../../../models/enum/enum-valid-value-item.model';
import { CfgARFeeDiscountModel } from '../../../../models/accountsReceivable/cfg-ar-fee-discount.model';
import { EnumFeeDiscountCalcTypeEnum } from '../../../../models/enum/enum-fee-discount-calc-type.enum';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { CaseItemSelectComponent } from '../../../case-forms/case-item-select/case-item-select.component';
import { ArCreateTransactionComponent } from '../ar-create-transaction/ar-create-transaction.component';
import { ToothSurfacePickerComponent } from '../tooth-surface-picker/tooth-surface-picker.component';
import { ARService } from '../../ar.service';
import { Globals } from '../../../../globals';
import { StaticDataService } from '../../../../services/static-data.service';
import { DialogService } from '../../../../services/dialog.service';
import { CaseFormsService } from '../../../case-forms/case-forms.service';
import { SalutationEnum } from '../../../../models/enum/salutation.enum';
import { FeeNoChargeReasonEnum } from '../../../../models/enum/fee-no-charge-reason.enum';
import { FeeScheduleDoctorDataARModel } from '../../../../models/accountsReceivable/fee-schedule-doctor-data-ar.model';
import { PatientInsuranceListViewDataModel } from '../../../insurance/models/patient-insurance-list-view-data-view.model';
import { Constants, LOCID } from '../../../../constants';
import { DoctorByTDOCIDModel } from '../../models/doctor-by-tdocid.model';
import { ARFeeErrorItem, ARFeeErrors } from '../../models/ar-fee-error-items';
import { PostTransactionItemModel } from '../../../../models/accountsReceivable/post-transaction-item.model';
import { ArFeeCalculationErrorComponent } from '../ar-fee-calculation-error/ar-fee-calculation-error.component';
import { DataPatientCaseWorkItemToothModel } from '../../../../models/teeth/data-patient-case-work-item-tooth.model';
import { ClaimTypeEnum } from '../../../../models/enum/claim-type.enum';
import { ClaimWizardComponent } from '../../claims/claim-wizard/claim-wizard.component';
import { LOCIDModel } from '../../models/select-tdocid-locid.model';
import { FeeItemCategoryIdEnum } from '../../../../models/enum/fee-item-category-id.enum';
import { TdoTableSelectionEvent } from 'src/app/tdo-controls/common/tdo-table-v2/models/tdo-table-selection.event';
import { MatCheckbox, MatCheckboxChange } from '@angular/material/checkbox';
import { PrintLedgerParamsModel } from 'src/app/models/accountsReceivable/print-ledgerParams.model';
import { ReportIDEnum } from 'src/app/models/enum/report-ID-enum';
import { TDOPrintService } from 'src/app/services/print/tdoprint.service';
import { ConversionUtilities } from 'src/app/utilities/conversion.utilities';
import { UiService } from 'src/app/services/ui.service';
import { ArFeeCalculationComponent } from '../ar-fee-calculation/ar-fee-calculation.component';

const AR_FEES_ORIGINAL_DOCTOR_STORAGE_KEY = 'arFeesOriginalDoctorByTransactionItemId';

@Component({
  standalone: false,
  selector: 'app-ar-fees-list',
  templateUrl: './ar-fees-list.component.html',
  styleUrls: ['./ar-fees-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ArFeesListComponent implements OnInit {
  @ViewChild('allFeesCheck') allFeesCheck: MatCheckbox;
  @Input() dataTransactionItems: DataARTransactionItemModel[] = [];
  @Input() PatientId;
  @Input() activeDoctorFeeSchedule: FeeScheduleDoctorDataARModel;
  @Input() activeOrganization: PatientInsuranceListViewDataModel = new PatientInsuranceListViewDataModel();
  @Input() postedTransactionItems: DataARTransactionItemModel[] = [];
  @Input() showPostedTransactions: boolean = false;
  @Input() ARisEstimating: boolean = true;
  @Input() selectAll: boolean = false;
  @Input() locations: LOCIDModel[] = [];
  @Input() doctorsByTDOCID: DoctorByTDOCIDModel[] = [];
  @Output() showPostedChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() itemSelected: EventEmitter<TdoTableSelectionEvent> = new EventEmitter<TdoTableSelectionEvent>();

  CaseWorkItemId: string = '';
  PatientCaseId: string = '';
  LOCID: number;

  feeDiscounts: CfgARFeeDiscountModel[] = [];
  isLoading: boolean = false;
  isTransactionItemsLoading: boolean = false;
  isPosting: boolean = false;
  toothMissingPost: boolean = false;
  OtherMissingPost: boolean = false;
  currentDate: Date = new Date();
  emptyGuid: string = Constants.emptyGuid;
  selectedClaimType: string;
  timeout: any = null;

  showTopActionButtons: boolean = true;
  showForDraw: boolean = false;

  enumCoverageTypePercent: string = EnumFeeDiscountCalcTypeEnum.Percent;
  enumCoverageTypeAmount: string = EnumFeeDiscountCalcTypeEnum.Money;
  salutationEnums: EnumValidValueItemModel[] = [];
  enumNoChargeReasons: EnumValidValueItemModel[] = [];
  enumFeeItemCategories: EnumValidValueItemModel[] = [];

  // new table
  // columnsToDisplayTopRow = ['DiscountID', 'TeethReference', 'Code', 'Description', 'Price', 'PriceAdjusted', 'InsuranceAmount', 'DeductibleAmount', 'PatientResponsibility', 'PresentedDate', 'ProviderDoctorId', 'DATA_POST'];
  // ^removed PriceAdjusted
  columnsToDisplayTopRow = ['DiscountID', 'TeethReference', 'Code', 'Description', 'Price', 'InsuranceAmount', 'DeductibleAmount', 'PatientResponsibility', 'PresentedDate', 'ProviderDoctorId', 'DATA_POST'];
  columnsToDisplayBottomRow = ['colspan2_insurance', 'colspan2_empty1', 'OriginalPrice', 'colspan2_nocharge', 'PostedDate', 'Location', 'end_row_empty'];
  hoverTransactionItemID: string = '';
  private originalDoctorIdByTransactionItemId = new Map<string, string>();
  updateFeeMethod: string = 'price';


  constructor(
    private readonly arService: ARService,
    private readonly dialog: MatDialog,
    public globals: Globals,
    private readonly staticDataService: StaticDataService,
    private readonly dialogService: DialogService,
    private readonly caseService: CaseFormsService,
    private readonly changeRef: ChangeDetectorRef,
    private readonly printService: TDOPrintService,
    private readonly uiService: UiService
  ) { }

  get benefitsLeft(): number {
    return this.activeOrganization ? (this.activeOrganization.BenefitsLeft - ConversionUtilities.roundDecimal(this.dataTransactionItems.reduce((n, { InsuranceAmount }) => n + InsuranceAmount, 0))): 0.00;
  };

  get deductibleLeft(): number {
    if (this.ARisEstimating) return 0;
    return this.activeOrganization ? (this.activeOrganization.BenefitsDeductibleLeft - ConversionUtilities.roundDecimal(this.dataTransactionItems.reduce((n, { DeductibleAmount }) => n + DeductibleAmount, 0))) : 0.00;
  };

  get preventativeDeductibleLeft(): number {
    if (!this.ARisEstimating) return 0;
    return this.activeOrganization ? (this.activeOrganization.BenefitsDeductableLeftPreventitive - ConversionUtilities.roundDecimal(this.dataTransactionItems.filter(({ enumFeeItemCategoryId }) => enumFeeItemCategoryId === FeeItemCategoryIdEnum.Preventative)
      .reduce((n, { DeductibleAmount }) => n + DeductibleAmount, 0))) : 0.00;
  }

  get basicDeductibleLeft(): number {
    if (!this.ARisEstimating) return 0;
    return this.activeOrganization ? (this.activeOrganization.BenefitsDeductableLeftStandard - ConversionUtilities.roundDecimal(this.dataTransactionItems.filter(({ enumFeeItemCategoryId }) => enumFeeItemCategoryId === FeeItemCategoryIdEnum.Basic)
      .reduce((n, { DeductibleAmount }) => n + DeductibleAmount, 0))):0.00;
  }

  get otherDeductibleLeft(): number {
    if (!this.ARisEstimating) return 0;
    return this.activeOrganization ? (this.activeOrganization.BenefitsDeductableLeftOther - ConversionUtilities.roundDecimal(this.dataTransactionItems.filter(({ enumFeeItemCategoryId }) => enumFeeItemCategoryId === FeeItemCategoryIdEnum.Other)
      .reduce((n, { DeductibleAmount }) => n + DeductibleAmount, 0))): 0.00;
  }

  ngOnInit(): void {

    console.log("ngOnInit this.ARisEstimating: ", this.ARisEstimating);

    this.staticDataService.validValuesReadyEvent.subscribe({
      complete: () => {

        this.salutationEnums = this.staticDataService.getValidValueItemsByItemIds([
          SalutationEnum.Dr,
          SalutationEnum.Prof,
          SalutationEnum.Mr,
          SalutationEnum.Mrs,
          SalutationEnum.Miss,
          SalutationEnum.Ms
        ]);

        this.enumNoChargeReasons = this.staticDataService.getValidValueItemsByItemIds([
          FeeNoChargeReasonEnum.Administrative,
          FeeNoChargeReasonEnum.Charity,
          FeeNoChargeReasonEnum.Latrogenic,
          FeeNoChargeReasonEnum.InternalStaff,
          FeeNoChargeReasonEnum.PersonalFriend,
          FeeNoChargeReasonEnum.ReferringDrStaff,
          FeeNoChargeReasonEnum.Religiouse,
          FeeNoChargeReasonEnum.SeniorCitizen,
          FeeNoChargeReasonEnum.Other
        ]);

        this.enumFeeItemCategories = this.staticDataService.getValidValueItemsByItemIds([
          FeeItemCategoryIdEnum.Preventative,
          FeeItemCategoryIdEnum.Basic,
          FeeItemCategoryIdEnum.Other
        ]);
      }
    });

    this.LOCID = parseInt(localStorage.getItem(LOCID));
    this.PatientId = this.globals.currentPatientId;
    this.PatientCaseId = this.globals.currentPatientCaseId;
    this.isLoading = true;
    this.originalDoctorIdByTransactionItemId = this.loadOriginalDoctorMapFromStorage();
    // copy doctor list to all fees
    this.dataTransactionItems.forEach(a => {
      a.doctorListDropdown = this.getDoctorDropdownOptions(a.ProviderDoctorId);
      if (!this.originalDoctorIdByTransactionItemId.has(a.ARTransactionItemID)) {
        this.originalDoctorIdByTransactionItemId.set(a.ARTransactionItemID, a.ProviderDoctorId);
        this.persistOriginalDoctorMap();
      }
    });

    // add post date if missing
    this.dataTransactionItems.forEach(a => {
      if (!a.PostDate) {
        a.PostDate = new Date();
      }
    });

    this.init();
  }

  async init() {

    const promises: any[] = [
      this.getDiscounts(),
    ];

    // this.isLoading = true;

    try {

      const results: any[] = await Promise.all(promises);
      this.feeDiscounts = results[0];


    } catch (err) {
      console.log(err);
      this.createMessage('Something went wrong', 'Error');
      this.isLoading = false;
      this.changeRef.detectChanges();
    }
  }

  loadPatientTransactionItems(recalculateBy: string = 's') {
    this.isLoading = true;
    this.isTransactionItemsLoading = true;
    this.changeRef.detectChanges();
    this.getPatientDataTransactionItems(this.PatientId, recalculateBy).then((result: DataARTransactionItemModel[]) => {
      if (result != null && result?.length > 0) {
        this.dataTransactionItems = result;
        this.hoverTransactionItemID = this.dataTransactionItems[0].ARTransactionItemID;
        // copy doctor list to all fees
        this.dataTransactionItems.forEach(a => {
          a.doctorListDropdown = this.getDoctorDropdownOptions(a.ProviderDoctorId);
          if (!this.originalDoctorIdByTransactionItemId.has(a.ARTransactionItemID)) {
            this.originalDoctorIdByTransactionItemId.set(a.ARTransactionItemID, a.ProviderDoctorId);
            this.persistOriginalDoctorMap();
          }
        });
      }
      else {
        this.dataTransactionItems = [];
        this.hoverTransactionItemID = '';
      }
      console.log("ended loading transactions");
      this.isTransactionItemsLoading = false;
      this.isLoading = false;
      this.isPosting = false;
      this.changeRef.detectChanges();
    })
    .catch(error => {
      console.error('There was a problem with the fetch operation:', error);
      this.createMessage('There was a problem obtaining the transactions, please try again.', 'Error');
      this.isLoading = false;
      this.isPosting = false;
      this.isTransactionItemsLoading = false;
      this.changeRef.detectChanges();
    });;
  }

  getTotalFee() {
    return ConversionUtilities.roundDecimal(this.dataTransactionItems.reduce((n, { DoctorsPrice }) => n + DoctorsPrice, 0));
  }
  getTotalInsuranceAmount() {
    return ConversionUtilities.roundDecimal(this.dataTransactionItems.reduce((n, { InsuranceAmount }) => n + InsuranceAmount, 0));
  }
  getTotalDeductible() {
    return ConversionUtilities.roundDecimal(this.dataTransactionItems.reduce((n, { DeductibleAmount }) => n + DeductibleAmount, 0));
  }
  getTotalPatientEstimate() {
    return ConversionUtilities.roundDecimal(this.dataTransactionItems.reduce((n, { PatientResponsibility }) => n + PatientResponsibility, 0));
  }


  isDiscountAvailable(ProviderDoctorId: string, level: number) {
    const feeDiscount = this.feeDiscounts.find(a =>
      a.DiscountName === 'Level' + level
      && a.ProviderDoctorId === ProviderDoctorId
      && a.LOCID === this.LOCID);
    if (feeDiscount && ProviderDoctorId) {
      if (
        (feeDiscount.enumFeeDiscountCalcTypeId === this.enumCoverageTypePercent && feeDiscount.DiscountPCT === 0)
        ||
        (feeDiscount.enumFeeDiscountCalcTypeId === this.enumCoverageTypeAmount && feeDiscount.DiscountAmount === 0)
      ) {
        return true;
      }
      else {
        return false;
      }
    }
    else {
      return true;
    }
  }

  toggleAllFeesSelected(e: MatCheckboxChange) {
    this.dataTransactionItems.forEach((item) => {
      item.DATA_POST = e.checked;
    });
  }
  toggleFeeSelected(e: MatCheckboxChange) {
    if (!e.checked && this.allFeesCheck.checked) {
      this.allFeesCheck.checked = false;
    }
  }

  editDetailForTransaction(transactionItem: DataARTransactionItemModel, key: string, searchCode: string = null) {
    transactionItem[key] = true;

    if (key === 'DATA_ENABLE_TOOTH_EDIT') {
      // this.openToothPickerForTransactionItem(transactionItem);
      this.openCaseWorkItemPickerForTransactionItem(transactionItem);
    }
    else if (key === 'DATA_ENABLE_TOOTH_SURFACE_EDIT') {
      this.openCaseWorkItemToothSurfacePickerForCaseWorkItemID(transactionItem.CaseWorkItemId, transactionItem.CaseWorkItemToothId, transactionItem.ARTransactionItemID);
    }
    else if (key === 'DATA_ENABLE_CODE_EDIT') {
      // this.openCodePickerForTransaction(transactionItem);
      this.openCreateTransactionItemComponent(transactionItem, searchCode);
    }
  }

  openCodePickerForTransaction(transactionItem: DataARTransactionItemModel) {
    // open window
    this.isTransactionItemsLoading = true;
    this.changeRef.markForCheck();
    const dialogRef = this.dialog.open(ArCreateTransactionComponent, {
      width: '800px',
      height: '650px',
      data: {
        PatientId: this.PatientId,
        PatientCaseId: this.PatientCaseId,
        DoctorId: this.activeDoctorFeeSchedule.enumDoctorTypeID === '00000004-1000-0000-0000-000000000003' ? this.globals.currentProviderDoctorID : this.activeDoctorFeeSchedule.DoctorId,
        feeScheduleID: this.activeDoctorFeeSchedule.FeeScheduleID,
        isCodeEdit: true,
        procedureCode: transactionItem.Code,
        ToothID: transactionItem.ToothID,
        TransactionDate: new Date(),
        OrganizationID: this.activeOrganization.OrganizationID,
        PatientInsuranceID: this.activeOrganization.PatientInsuranceID,
        DocFeeScheduleID: this.activeDoctorFeeSchedule.DocFeeScheduleID,
        caseWorkItemID: transactionItem.CaseWorkItemId,
        // ProviderDoctorID: this.activeDoctorFeeSchedule.DoctorId
      }
    });

    // window closed
    dialogRef.afterClosed().subscribe(async result => {

      this.changeRef.markForCheck();
      if (!result) {
        return;
      } else {
        // reload list
        // this.init();
        this.loadPatientTransactionItems();
      }
    }, err => {
    });
  }

  openCaseWorkItemPickerForTransactionItem(transactionItem: DataARTransactionItemModel) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.panelClass = 'dialog';
    dialogConfig.data = {
      isMultiSelect: false,
      PatientCaseId: this.PatientCaseId,
      TransactionItem: transactionItem
    };

    const dialogRef = this.dialog.open(CaseItemSelectComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(async result => {
      this.changeRef.markForCheck();
      if (result) {
        this.loadPatientTransactionItems();
      }
    }, err => {
    });
  }

  openCaseWorkItemToothSurfacePickerForCaseWorkItemID(CaseWorkItemID: string, CaseWorkItemToothId: string, ARTransactionItemID: string | null = null) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.panelClass = 'dialog';
    dialogConfig.data = {
      isMultiSelect: false,
      caseWorkItemId: CaseWorkItemID,
      caseWorkItemToothId: CaseWorkItemToothId,
      arTransactionItemId: ARTransactionItemID
    };

    const dialogRef = this.dialog.open(ToothSurfacePickerComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(async result => {
      if (result) {
        this.loadPatientTransactionItems();
      }
    }, err => {
    });
  }

  hasToothSurface(teethReference: string) {
    return /[BDLMO]/gi.test(teethReference);
  }

  saveTransactionItem(transactionItem) {
    const itemClone = JSON.parse(JSON.stringify(transactionItem));
    itemClone.dataARTransaction = null;
    itemClone.dataPatientCaseWorkItem = null;
    itemClone.DATA_cfgCaseProcedure = null;
    itemClone.dataARClaims = [];
    itemClone.dataDoctor = null;
    return this.arService.saveTransactionItem(itemClone).toPromise();
  }

  setPostDate(transactionItem: DataARTransactionItemModel, date: Date = null) {
    transactionItem.PostDate = date ? date : new Date();
    //transactionItem.PostDate.setUTCHours(12,0,0,0);
    this.saveTransactionItem(transactionItem);
  }

  setPresentedDate(transactionItem: DataARTransactionItemModel, date: Date = null) {
    transactionItem.PresentedDate = date ? date : new Date();
    //transactionItem.PresentedDate.setUTCHours(12,0,0,0);
    this.saveTransactionItem(transactionItem);
  }

  returnSalutation(enumValue: string) {

    if (enumValue) {
      enumValue = enumValue.toUpperCase();
      if (enumValue === SalutationEnum.Dr) {
        return 'Dr. ';
      }
      else if (enumValue === SalutationEnum.Prof) {
        return 'Prof. ';
      }
      else if (enumValue === SalutationEnum.Mr) {
        return 'Mr. ';
      }
      else {
        return '';
      }
    } else {
      return '';
    }
  }


  async removeItem(transactionItem: DataARTransactionItemModel) {
    this.dialogService.openConfirmDialog(`Do you want to remove item? <br><b>${transactionItem.Description}</b>.`).subscribe(async (response) => {
      if (response) {
        this.isTransactionItemsLoading = true;
        this.isLoading = true;
        const promises = [this.deleteTransactionItem(transactionItem)];

        try {
          await Promise.all(promises);
          this.originalDoctorIdByTransactionItemId.delete(transactionItem.ARTransactionItemID);
          this.persistOriginalDoctorMap();
          this.createMessage('Item removed', 'Success');
          this.loadPatientTransactionItems();
          this.isTransactionItemsLoading = false;
          this.isLoading = false;
        } catch (err) {
          this.createMessage('Something went wrong', 'Error');
          this.isTransactionItemsLoading = false;
          this.isLoading = false;
        }
      }
    });

  }

  saveTransactionItemUpdateFees(event, transactionItem: DataARTransactionItemModel, PatientID: string, itemChanged: number) {
    this.isTransactionItemsLoading = true;

    let num = 0;
    if (itemChanged !== 0 && itemChanged !== 8 && itemChanged !== 9 && itemChanged !== 11) {
      num = Number(event.value.replace(/[^0-9.-]+/g, ''));
    }
    // itemChanged = 0 : ProviderDoctorID
    // itemChanged = 1 : NOT USED
    // itemChanged = 2 : Price
    // itemChanged = 3 : Deductible
    // itemChanged = 4 : NOT USED
    // itemChanged = 5 : InsuranceAmount
    // itemChanged = 6 : PatientResponsibility
    // itemChanged = 7 : DoctorsPrice
    // itemChanged = 8 : Location
    // itemChanged = 9 : NoCharge


    // update transaction item with value passed
    if (itemChanged === 5) {
      transactionItem.InsuranceAmount = num;
    }
    else if (itemChanged === 2) {
      transactionItem.Price = num;
    }
    else if (itemChanged === 3) {
      transactionItem.DeductibleAmount = num;
    }
    else if (itemChanged === 6) {
      transactionItem.PatientResponsibility = num;
    }
    else if (itemChanged === 7) {
      transactionItem.DoctorsPrice = num;
    }

    this.postSaveTransactionUpdateFees(transactionItem, PatientID, itemChanged).then((result) => {
      if (result != null) {
        this.loadPatientTransactionItems();
      }
    }
    );
  }

  postSaveTransactionUpdateFees(transactionItem: DataARTransactionItemModel, PatientID: string, itemChanged: number) {
    return this.arService.saveTransactionItemUpdateFees(transactionItem, PatientID, itemChanged).toPromise();
  }

  clearReason(transactionItem: DataARTransactionItemModel, $event: any) {
    if (!$event.checked) {
      transactionItem.enumARNoChargeReasonID = null;
    }
  }

  // adjustments...

  applyDiscount(transactionItem: DataARTransactionItemModel, level: number) {
    this.isTransactionItemsLoading = true;

    // get adjustment amount
    const feeDiscount = this.feeDiscounts.find(a =>
      a.DiscountName === 'Level' + level
      && a.ProviderDoctorId === transactionItem.ProviderDoctorId
      && a.LOCID === this.LOCID);

    // modify transactionItem.DoctorsPrice
    if (feeDiscount) {
      if (feeDiscount.enumFeeDiscountCalcTypeId === EnumFeeDiscountCalcTypeEnum.Percent) {
        transactionItem.DoctorsPrice = transactionItem.DoctorsPrice + ((feeDiscount.DiscountPCT / 100) * transactionItem.DoctorsPrice);
        transactionItem.Price = transactionItem.DoctorsPrice;

        // (35.8 / 100) * 10000;
      }
      else if (feeDiscount.enumFeeDiscountCalcTypeId === EnumFeeDiscountCalcTypeEnum.Money) {
        transactionItem.DoctorsPrice = transactionItem.DoctorsPrice + feeDiscount.DiscountAmount;
        transactionItem.Price = transactionItem.DoctorsPrice;
      }
    }

    this.saveTransactionItemUpdateFees(transactionItem.DoctorsPrice, transactionItem, this.PatientId, 11);
  }

  isDiscountApplied(discountId: string, level: number) {
    const feeDiscount = this.feeDiscounts.find(a => a.DiscountID === discountId && a.DiscountName === 'Level' + level);
    if (feeDiscount) {
      return true;
    }
    else {
      return false;
    }
  }

  getDiscountAmountForTooltip(transactionItem: DataARTransactionItemModel, level: number) {
    const feeDiscount = this.feeDiscounts.find(a =>
      a.DiscountName === 'Level' + level
      && a.ProviderDoctorId === transactionItem.ProviderDoctorId
      && a.LOCID === this.LOCID);
    if (feeDiscount) {
      if (feeDiscount.enumFeeDiscountCalcTypeId === EnumFeeDiscountCalcTypeEnum.Percent) {
        return feeDiscount.DiscountPCT + '%';
      }
      else if (feeDiscount.enumFeeDiscountCalcTypeId === EnumFeeDiscountCalcTypeEnum.Money) {
        return '$' + feeDiscount.DiscountAmount;
      }
      else {
        return 'No Adjustment Available';
      }
    }
    else {
      return 'No Adjustment Available';
    }
  }

  createMessage(message, type) {
    this.uiService.displayMessage(type, message);    
  }

  recalculateFeeTable() {
    this.loadPatientTransactionItems(this.updateFeeMethod);
  }
  onRowSelected(row): void {
    const model = new TdoTableSelectionEvent();
    if (this.hoverTransactionItemID != row.ARTransactionItemID) {
      this.hoverTransactionItemID = row.ARTransactionItemID;
      model.isSelected = true;

    }
    else {
      this.hoverTransactionItemID = '';
      model.isSelected = false;
    }
    model.model = row;
    model.isMultiSelection = false;

    this.itemSelected.emit(model);
  }

  async postSelectedTransactions(blIgnoreMissingTeeth: boolean, transactionItemID: string) {

    // Guard against double-click / re-entry. The first awaited call (credits fetch +
    // confirm dialog) happens before any loading flag is set, so a fast second click
    // would post the same transactions again with a new transaction ID (TX-6952).
    if (this.isPosting) {
      return;
    }
    this.isPosting = true;

    let usePatientCredits = false;
    let patientCredits;
    try {
      patientCredits = await this.arService.getCreditsForLedger(this.PatientId).toPromise();
      // console.log('patientCredits: ', patientCredits);
      if (patientCredits.AmountPatient > 0) {
        const useDialog = await this.dialogService.openConfirmDialog(`Patient has $${patientCredits.AmountPatient.toFixed(2)} in credits. Do you want to apply it to the selected transactions?`, true, false).toPromise();
        // console.log('useDialog: ', useDialog);
        if (useDialog === true) {
          usePatientCredits = true;
        }
      }
    } catch (err) {
      // Release the re-entry guard so the button is usable again after a failed pre-check.
      this.isPosting = false;
      throw err;
    }
    // console.log('usePatientCredits: ', usePatientCredits);
    this.isTransactionItemsLoading = true;
    this.changeRef.markForCheck();

    let blError = false;
    let numRowCount: number = 0;
    const errorObject = new ARFeeErrors();

    this.toothMissingPost = false;
    this.OtherMissingPost = false;

    // **** single item passed
    if (transactionItemID) {
      const tItem = this.dataTransactionItems.find(a => a.ARTransactionItemID === transactionItemID);
      tItem.DATA_POST = true;

      // check for completed fields
      numRowCount++;
      const errorObjectTemp = this.returnErrorList(tItem, numRowCount);
      if (errorObjectTemp.transactionItemNumber) {
        errorObject.ARFeeErrorItems.push(errorObjectTemp);
        blError = true;
      }
    }
    else {
      // **** possible multiple items passed
      this.dataTransactionItems.forEach(transactionItem => {

        // single item passed
        if (transactionItemID) {
          transactionItem.DATA_POST = true;

          // check for completed fields
          numRowCount++;
          const errorObjectTemp = this.returnErrorList(transactionItem, numRowCount);
          if (errorObjectTemp.transactionItemNumber) {
            errorObject.ARFeeErrorItems.push(errorObjectTemp);
            blError = true;
          }
        }
        else if (transactionItem.DATA_POST) {

          // check for completed fields
          numRowCount++;

          const errorObjectTemp = this.returnErrorList(transactionItem, numRowCount);
          if (errorObjectTemp.transactionItemNumber) {
            errorObject.ARFeeErrorItems.push(errorObjectTemp);
            blError = true;
          }
        }
      });
    }

    // if there are items with incomplete fields
    if (blError) {
      this.openPostItemsError(errorObject, null, false);
      this.isTransactionItemsLoading = false;
      // Released here so the tooth-missing "resume post" path (openPostItemsError ->
      // postSelectedTransactions(true, null)) is not blocked by the re-entry guard.
      this.isPosting = false;
    }
    else {
      const transactionsToPost: DataARTransactionItemModel[] = [];

      // **** single item passed
      if (transactionItemID) {
        const tItem = this.dataTransactionItems.find(a => a.ARTransactionItemID === transactionItemID);
        transactionsToPost.push(tItem);
      }
      else {
        // **** possible multiple items passed
        this.dataTransactionItems.forEach(transactionItem => {
          if (transactionItem.DATA_POST) {
            transactionsToPost.push(transactionItem);
          }
        });
      }

      if (!transactionsToPost.length) {
        this.isTransactionItemsLoading = false;
        this.isPosting = false;
        this.changeRef.markForCheck();
        return;
      }

      const inactiveDoctorNames = this.getInactiveDoctorNames(transactionsToPost);
      if (inactiveDoctorNames.length) {
        this.createMessage(
          `${inactiveDoctorNames.join(', ')} ${inactiveDoctorNames.length > 1 ? 'are' : 'is'} inactive. This fee's amounts were calculated using an inactive doctor and will not be recalculated by changing the doctor. Please add a new fee with an active doctor to recalculate the amounts.`,
          'Warning'
        );
        this.isTransactionItemsLoading = false;
        this.isPosting = false;
        this.changeRef.markForCheck();
        return;
      }

      // post date
      transactionsToPost.forEach(item => {
        if (!item.PostDate) {
          item.PostDate = new Date();
        }
        item.PostDateString = item.PostDate.toLocaleString();
      });

      const postTransItems = new PostTransactionItemModel();
      postTransItems.LOCID = this.LOCID;
      postTransItems.PatientId = this.PatientId;
      postTransItems.transactionItems = transactionsToPost;
      postTransItems.ProviderDoctorId = this.globals.currentProviderDoctorID;
      postTransItems.UsePatientCredits = usePatientCredits;

      this.isLoading = true;

      try {
        this.isTransactionItemsLoading = true;
        this.changeRef.markForCheck();
        await this.arService.postTransactionItems(postTransItems).toPromise();
        transactionsToPost.forEach(item => this.originalDoctorIdByTransactionItemId.delete(item.ARTransactionItemID));
        this.persistOriginalDoctorMap();
        this.createMessage('Transaction(s) posted', 'Success');
      } catch (err) {
        console.error(err);
        const backendMsg = err?.error?.Message || err?.error?.message;
        this.createMessage(backendMsg || 'Something went wrong', 'Error');
      }

      this.isLoading = false;
      
      this.loadPatientTransactionItems();
    }
  }

  returnErrorList(transactionItem: DataARTransactionItemModel, itemNumber: number) {
    const errorObject = new ARFeeErrorItem();

    if (transactionItem.Code) {
      if (transactionItem.Code.trim() === '') {
        errorObject.errorListRequired.push('Procedure Code');
        this.OtherMissingPost = true;
      }
    }
    else {
      errorObject.errorListRequired.push('Procedure Code');
      this.OtherMissingPost = true;
    }

    if (transactionItem.Price === null) {
      errorObject.errorListRequired.push('Original Price');
      this.OtherMissingPost = true;
    }
    if (transactionItem.DoctorsPrice === null) {
      errorObject.errorListRequired.push('Doctors Price');
      this.OtherMissingPost = true;
    }
    if (transactionItem.DeductibleAmount === null) {
      errorObject.errorListRequired.push('Deductible');
      this.OtherMissingPost = true;
    }
    if (transactionItem.PriceAdjusted === null) {
      errorObject.errorListRequired.push('Fee');
      this.OtherMissingPost = true;
    }
    if (transactionItem.InsuranceAmount === null) {
      errorObject.errorListRequired.push('Insurance Amount');
      this.OtherMissingPost = true;
    }
    if (transactionItem.PatientResponsibility === null) {
      errorObject.errorListRequired.push('Patient');
      this.OtherMissingPost = true;
    }
    // else if (transactionItem.PatientResponsibility <= 0) {
    //   errorObject.errorListRequired.push('Patient fee cannot be zero');
    //   this.OtherMissingPost = true;
    // }
    // if (transactionItem.PostDate === null) {
    //   errorObject.errorListRequired.push('Post Date');
    //   this.OtherMissingPost = true;
    // }
    if (transactionItem.ProviderDoctorId === null || transactionItem.ProviderDoctorId === this.emptyGuid) {
      errorObject.errorListRequired.push('Doctor');
      this.OtherMissingPost = true;
    }

    if (transactionItem.TeethReference) {
      if (transactionItem.TeethReference === '') {
        errorObject.errorListRequired.push('Tooth');
        this.OtherMissingPost = true;
      }
    }
    else {
      errorObject.errorListRequired.push('Tooth');
      this.OtherMissingPost = true;
    }
    //Validate that original price is not less than contracted price
    if (transactionItem.Price < transactionItem.DoctorsPrice) {
      errorObject.errorListRequired.push('Original Price cannot be less than default fee');
      this.OtherMissingPost = true;
    }

    if (errorObject.errorListRequired.length > 0 || errorObject.errorListOptional.length > 0) {
      errorObject.transactionItemCode = transactionItem.Code ? transactionItem.Code : 'Unknown Code';
      errorObject.transactionItemNumber = itemNumber;
    }

    return errorObject;
  }

  openPostItemsError(errorObject: ARFeeErrors, Message: string, blOverwrite: boolean) {
    const dialogConfig = new MatDialogConfig();

    if (Message && blOverwrite) {
      dialogConfig.data = {
        message: Message,
        errorObj: errorObject
      };
    }
    else {
      dialogConfig.data = {
        message: null,
        errorObj: errorObject
      };
    }
    dialogConfig.panelClass = 'dialog';
    if (this.OtherMissingPost) {
      dialogConfig.data.showCancel = false;
    }
    else {
      dialogConfig.data.showCancel = true;
    }

    const dialogRef = this.dialog.open(ArFeeCalculationErrorComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(async result => {

      if (!result) {
        return;
      }

      // if yes, proceed with posting
      if (result) {
        if (this.toothMissingPost && !this.OtherMissingPost) {
          // resume post
          this.postSelectedTransactions(true, null);
        }
      }
    }, err => {
    });
  }

  openCreateTransactionItemComponent(transactionItem: DataARTransactionItemModel = null, searchCode: string = null) {
    // if transaction item not passed...
    if (transactionItem === null) {
      if (!this.activeDoctorFeeSchedule) {
        this.createMessage('A fee schedule has not been created for the selected insurance. One must be created in order to select procedures.', 'Warning');
      }
      else {
        // Use sessionStorage for tab-isolated CaseWorkItemID to prevent cross-tab data corruption
        const sessionCaseWorkItemID = ArFeeCalculationComponent.getSessionCaseWorkItemID();

        // Check if we have a valid CaseWorkItemID (must be a valid GUID with 36 chars)
        if (!sessionCaseWorkItemID || sessionCaseWorkItemID.length < 34) {
          this.createMessage('Please select a Case/Procedure to create a fee for patient in Case View', 'Warning');
        }
        else {
          // if we get this far, then we need to make sure that a tooth exists before proceeding
          this.loadCreateFeeIfRequirementsMet(sessionCaseWorkItemID);
        }
      }
    }
    else {
      // transaction item was passed
      if (!this.activeDoctorFeeSchedule) {
        this.createMessage('A fee schedule has not been created for the selected insurance. One must be created in order to select procedures.', 'Warning');
      }
      else {
        // if we get this far, then we need to make sure that a tooth exists before proceeding
        this.loadCreateFeeIfRequirementsMet(transactionItem.CaseWorkItemId, transactionItem.ARTransactionItemID, searchCode);
      }
    }
  }

  async loadCreateFeeIfRequirementsMet(caseWorkItemId: string, transactionItemId: string = null, SearchCode: string = null) {


    if (caseWorkItemId == null) {
      this.createMessage('Please select a case Procedure. You must select a case and procedure to create a fee.', 'Warning');
    }


    const promises: any[] = [

      this.getCaseWorkItemTeeth(caseWorkItemId),
      this.getCaseWorkItemDoctor(caseWorkItemId)
    ];

    try {
      const results: any[] = await Promise.all(promises);
      const teeth: DataPatientCaseWorkItemToothModel[] = results[0];
      const doctor: number = results[1];
      if ((teeth.length > 0 && doctor > 0) || transactionItemId) {
        // passed requirements test for adding fees
        // load fee creation

        const dialogRef = this.dialog.open(ArCreateTransactionComponent, {
          panelClass: 'dialog',
          data: {
            PatientId: this.PatientId,
            PatientCaseId: this.PatientCaseId,
            DoctorId: this.globals.currentProviderDoctorID, // this.activeDoctorFeeSchedule.DoctorId,
            feeScheduleID: this.activeDoctorFeeSchedule.FeeScheduleID,
            isCreate: true,
            TransactionDate: new Date(),
            OrganizationID: this.activeOrganization.OrganizationID,
            PatientInsuranceID: this.activeOrganization.PatientInsuranceID,
            InsuranceID: this.activeOrganization.InsuranceID,
            DocFeeScheduleID: this.activeDoctorFeeSchedule.DocFeeScheduleID,
            caseWorkItemID: caseWorkItemId,
            transactionItemID: transactionItemId,
            searchCode: SearchCode,
            isDefaultInsurance: this.activeOrganization.isDefault
          }
        });
        dialogRef.afterClosed().subscribe(result => {
          this.changeRef.markForCheck();
          if (result) {
            this.loadPatientTransactionItems();
          }
          else {
            // picker returned false
            // if this was a code search
            if (transactionItemId && SearchCode) {
              // clear out code search criteria
              const transItem = this.dataTransactionItems.find(a => a.ARTransactionItemID === transactionItemId);
              if (transItem) {
                transItem.Code = transItem.CodeBackupValue;
              }
            }
          }
        }, err => {
        });
      }
      else {
        // failed requirements test for adding fees
        this.createMessage('The selected case/procedure does not have a tooth and a doctor assigned to it. Please assign a tooth and a doctor to the selected case/Procedure in Case View in order to create a fee for the patient.', 'Warning');
      }
    } catch (err) {
      console.log(err);
      this.createMessage('There was an error checking for procedure requirements', 'Error');
    }
  }

  isValidBenefitsAmount() {
    const isValidAmount = ((!this.ARisEstimating && this.benefitsLeft >= 0 && this.deductibleLeft >= 0)
      || (this.ARisEstimating && this.benefitsLeft >= 0
        && this.preventativeDeductibleLeft >= 0 && this.otherDeductibleLeft >= 0 && this.basicDeductibleLeft >= 0));
    return isValidAmount;

  }

  calcTransactionsSelected() {
    let flag = false;
    this.dataTransactionItems.forEach(transactionItem => {
      if (transactionItem.DATA_POST) {
        flag = true;
      }
    });

    return flag;
  }

  async printFeeCalculation(){
       const feeCalculationParameters = new PrintLedgerParamsModel();
       feeCalculationParameters.EnterpriseID = localStorage.getItem('TDOEnterpriseId');
       feeCalculationParameters.LOCID = this.LOCID;
       feeCalculationParameters.PatientID = this.PatientId;
       feeCalculationParameters.ReportId = ReportIDEnum.reportID_FeeCalculationReport;
       try {
             let documentID = await this.printService.printReport( ReportIDEnum.reportID_FeeCalculationReport, feeCalculationParameters).toPromise();
             this.printService.executePrint([documentID]);
           }
       catch (error) {
         this.createMessage('Error when trying to print Document.', 'error');
       }
  }

  async removeSelectedItems() {
    this.dialogService.openConfirmDialog('Do you want to remove the selected items?').subscribe(async (response) => {
      if (response) {
        const selectedItems = this.dataTransactionItems.filter(transactionItem => {
          return transactionItem.DATA_POST;
        });

        const promises = selectedItems.map(transactionItem => {
          return this.deleteTransactionItem(transactionItem);
        });

        this.isLoading = true;

        try {
          const results: any[] = await Promise.all(promises);
          selectedItems.forEach(transactionItem => this.originalDoctorIdByTransactionItemId.delete(transactionItem.ARTransactionItemID));
          this.persistOriginalDoctorMap();
          this.createMessage('Items removed', 'Success');
        } catch (err) {
          this.createMessage('Something went wrong', 'Error');
        }

        this.isLoading = false;
        this.loadPatientTransactionItems();
      }
    });
  }

  openClaimWizardYN() {
    const ignoreMissingTeeth = false;
    const claimType = this.selectedClaimType;
    if (claimType === 'real') {
      this.dialogService.openConfirmDialog('Proceeding will result in selected fees being posted to the ledger.').subscribe((res) => {
        if (res) {
          this.openClaimWizard(ignoreMissingTeeth);
        }
      });
    }
    else {
      this.openClaimWizard(ignoreMissingTeeth);
    }
  }

  openClaimWizard(blIgnoreMissingTeeth: boolean) {

    const claimType = this.selectedClaimType;
    let blError = false;
    let numRowCount: number = 0;
    const errorObject = new ARFeeErrors();

    this.toothMissingPost = false;
    this.OtherMissingPost = false;

    this.dataTransactionItems.forEach(transactionItem => {
      if (transactionItem.DATA_POST) {

        // check for completed fields
        numRowCount++;

        const errorObjectTemp = this.returnErrorList(transactionItem, numRowCount);
        if (errorObjectTemp.transactionItemNumber) {
          errorObject.ARFeeErrorItems.push(errorObjectTemp);
          blError = true;
        }
      }
    });

    let claimEnumType = '';
    if (claimType === 'pre') {
      claimEnumType = ClaimTypeEnum.Predetermination;
    }
    else if (claimType === 'real') {
      claimEnumType = ClaimTypeEnum.RealClaim;
    }

    // if there are items with incomplete fields
    if (blError && !blIgnoreMissingTeeth) {
      if (this.OtherMissingPost) {
        this.openClaimsItemsError(errorObject, null, false);
      }
      else {
        this.openClaimsItemsError(null, 'One or more transactions do not have a tooth specified.\n\nAre you sure that you would like to continue with the claim?', true);
      }
    }
    else {

      // build list of transaction items to claim
      const transactionsToClaim: DataARTransactionItemModel[] = [];
      this.dataTransactionItems.forEach(transactionItem => {
        if (claimType === 'pre') {
          transactionsToClaim.push(transactionItem);

        } else {
          if (transactionItem.DATA_POST) {
            transactionItem.PostDate = this.currentDate;
            transactionsToClaim.push(transactionItem);
          }
        }
      });






      if (transactionsToClaim.length > 0) {
        // only open dialog if transactions were selected and are valid
        const dialogRef = this.dialog.open(ClaimWizardComponent, {
          width: '1250px',
          height: '800px',
          panelClass: 'dialog',
          data: {
            PatientId: this.PatientId,
            dataTransactionItems: transactionsToClaim,
            postedTransactionItems: this.postedTransactionItems,
            doctors: this.doctorsByTDOCID,
            selectedClaimType: claimEnumType
            // the call to get this.dataPatient in onInit takes forever then dies, need to rewrite
            // dataPatient: this.dataPatient,
          }
        });
        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            this.init();
          }
        }, err => {
        });
      }
    }
  }

  openClaimsItemsError(errorObject: ARFeeErrors, Message: string, blOverwrite: boolean) {
    const dialogConfig = new MatDialogConfig();

    if (Message && blOverwrite) {
      dialogConfig.data = {
        message: Message,
        errorObj: errorObject
      };
    }
    else {
      dialogConfig.data = {
        message: null,
        errorObj: errorObject
      };
    }

    dialogConfig.panelClass = 'dialog';
    if (this.OtherMissingPost) {
      dialogConfig.data.showCancel = false;
    }
    else {
      dialogConfig.data.showCancel = true;
    }

    const dialogRef = this.dialog.open(ArFeeCalculationErrorComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(async result => {

      if (!result) {
        return;
      }

      // if yes, proceed with claims
      if (result) {
        if (this.toothMissingPost && !this.OtherMissingPost) {
          // resume post
          this.openClaimWizard(true);
        }
      }
    }, err => {
    });
  }

  updateShowPosted() {
    console.log('updateShowPosted');
    this.showPostedChange.emit(!this.showPostedTransactions);
  }

  onCodeSearch(event: any, transactionItem, searchCode: string) {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(a => {
      this.editDetailForTransaction(transactionItem, 'DATA_ENABLE_CODE_EDIT', searchCode);
    }, 1000);
  }


  // service calls...

  getCaseWorkItemTeeth(caseWorkItemId: string) {
    return this.caseService.getCaseWorkItemTeeth(caseWorkItemId).toPromise();
  }

  getCaseWorkItemDoctor(caseWorkItemId: string) {
    return this.caseService.getCaseWorkItemDoctor(caseWorkItemId).toPromise();
  }

  getDoctorsByTDOCID() {
    return this.arService.getDoctorsByTDOCIDFees().toPromise();
  }

  getDiscounts() {
    return this.arService.getDiscounts(this.LOCID).toPromise();
  }

  getPatientDataTransactionItems(PatientId: string, calculateBy: string = 's') {
    return this.arService.getPatientDataTransactionItems(PatientId, calculateBy).toPromise();
  }

  removeDiscountOnServerService(transactionItem: DataARTransactionItemModel) {
    return this.arService.removeDiscountOnServer(transactionItem).toPromise();
  }

  applyDiscountOnServerService(transactionItem: DataARTransactionItemModel, level: number) {
    return this.arService.applyDiscountOnServer(transactionItem, level, this.PatientId).toPromise();
  }

  deleteTransactionItem(transactionItem: any) {
    return this.arService.deleteTransactionItem(transactionItem).toPromise();
  }

  getLocations() {
    return this.arService.getLocations().toPromise();
  }

  selectAllItems() {
    if (!this.selectAll) {
      this.dataTransactionItems.forEach(transactionItem => {
        transactionItem.DATA_POST = true;
      });
    }
    else {
      this.dataTransactionItems.forEach(transactionItem => {
        transactionItem.DATA_POST = false;
      });
    }
  }

  private loadOriginalDoctorMapFromStorage(): Map<string, string> {
    try {
      const raw = localStorage.getItem(AR_FEES_ORIGINAL_DOCTOR_STORAGE_KEY);
      return raw ? new Map(Object.entries(JSON.parse(raw))) : new Map<string, string>();
    } catch {
      return new Map<string, string>();
    }
  }

  private persistOriginalDoctorMap(): void {
    try {
      localStorage.setItem(AR_FEES_ORIGINAL_DOCTOR_STORAGE_KEY, JSON.stringify(Object.fromEntries(this.originalDoctorIdByTransactionItemId)));
    } catch {
      // Storage unavailable/quota exceeded — original-doctor tracking degrades to in-memory-only for this session.
    }
  }

  private getInactiveDoctorNames(transactionsToPost: DataARTransactionItemModel[]): string[] {
    const names = new Set<string>();
    transactionsToPost.forEach(item => {
      const originalDoctorId = this.originalDoctorIdByTransactionItemId.get(item.ARTransactionItemID) ?? item.ProviderDoctorId;
      const doctor = this.returnDoctorObjByID(originalDoctorId);
      if (doctor && !doctor.isActiveDoctor) {
        names.add(this.returnDoctorNameByDoctorObj(doctor));
      }
    });
    return Array.from(names);
  }

  returnDoctorObjByID(doctorId: string) {
    let obj: DoctorByTDOCIDModel = null;
    this.doctorsByTDOCID.forEach(a => {
      if (doctorId === a.DoctorId) {
        obj = a;
      }
    });
    return obj;
  }

  returnDoctorNameByDoctorObj(doctor: DoctorByTDOCIDModel) {
    if (doctor) {
      const sal: string = this.returnSalutation(doctor.enumSalutationID);
      return sal + doctor.FirstName + ' ' + doctor.LastName;
    }
    else {
      return '';
    }
  }

  returnDoctorNameByID(doctorId: string) {
    if (doctorId) {
      const docObj = this.returnDoctorObjByID(doctorId);
      if (docObj) {
        const docName = this.returnDoctorNameByDoctorObj(docObj);
        return docName;
      }
      else {
        return '';
      }
    }
    else {
      return '';
    }
  }

  returnDoctorForDropdown(row: DataARTransactionItemModel) {
    return row.doctorListDropdown.find(a => a.DoctorId === row.ProviderDoctorId);
  }

  private getDoctorDropdownOptions(assignedDoctorId: string): DoctorByTDOCIDModel[] {
    const activeDoctors = this.doctorsByTDOCID.filter(d => d.isActiveDoctor);
    if (assignedDoctorId && !activeDoctors.some(d => d.DoctorId?.toLowerCase() === assignedDoctorId.toLowerCase())) {
      const inactiveAssigned = this.doctorsByTDOCID.find(d => d.DoctorId?.toLowerCase() === assignedDoctorId.toLowerCase());
      if (inactiveAssigned) {
        return [...activeDoctors, inactiveAssigned];
      }
    }
    return activeDoctors;
  }

}
